var NavFactory = function() {
    // consist of objects { niceName, name }
    var selected = {
        make: {},
        model: {},
        submodel: {},
        year: {}
    };

    this.resetSelected = function() {
        selected = {
            make: {},
            model: {},
            submodel: {},
            year: {}
        };
    };

    this.getSelected = function() {
        return selected;
    };

    this.setMake = function(value) {
        selected['make'] = value;
    };

    this.setModel = function(value) {
        selected['model'] = value;
    };

    this.setSubmodel = function(value) {
        selected['submodel'] = value;
    };

    this.setYear = function(value) {
        selected['year'] = value;
    };
};

module.exports = new NavFactory();


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/nav-factory.js
// module id = 3
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14